/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"

import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import BihinzaikoService from "../../../service/purchase/bihinzaiko/bihinzaikoService"

import { TApiResponse } from "../../../service/TApiResponse"
import { RootState } from "../../../globalStore/rootreducer"
import { e受払区分 } from "../../../constant/enum/zyutuHaisya"

const PurchaseBihinzaikoRegister = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const disPatch: AppDispatch = useDispatch()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [受払日, set受払日] = useState<string>(eigyobi)
  const [備品コード, set備品コード] = useState<string>("")
  const [備品名, set備品名] = useState<string>("")
  const [サイズ, setサイズ] = useState<string>("")
  const [単位, set単位] = useState<string>("")
  const [ロット, setロット] = useState<string>("")
  const [払出単価, set払出単価] = useState<number>(0)
  const [在庫数量, set在庫数量] = useState<number>(0)
  const [受入数量, set受入数量] = useState<number>(0)
  const [在庫場所, set在庫場所] = useState<string>("")
  const [備考, set備考] = useState<string>("")
  const [更新日時, set更新日時] = useState<string>("")

  const [buttonName, setButtonName] = useState<string>("")

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: string) => {
    const service = new BihinzaikoService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set備品コード(res.data.備品コード)
        set備品名(res.data.備品名)
        setサイズ(res.data.サイズ)
        set単位(res.data.単位)
        setロット(res.data.ロット)
        set払出単価(res.data.払出単価)
        set在庫数量(res.data.在庫数量)
        set在庫場所(res.data.在庫場所)
        set備考(res.data.備考)
        set更新日時(res.data.更新日時)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    // 受払日、受払数量、備品コード、備品名が必須
    if (!isValidationCheck()) return
    setIsConfirmModalShow(true)
  }

  /**
   * 登録時チェック
   * @returns
   */
  const isValidationCheck = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // 新規/更新によりチェック分岐する
    if (id) {
      // 更新時
      // 必須チェック
      if (受入数量 == null) {
        messages.push(`受入数量は、0以上の値を入力してください。`)
        hasError = true
      }
    } else {
      // 登録時
      // 必須/負数チェック
      if (受入数量 == null || Math.sign(受入数量) === -1) {
        messages.push(`受入数量は、0以上の値を入力してください。`)
        hasError = true
      }
    }

    // 必須チェック
    if (受払日 == null) {
      // isRequired=trueなので本来あり得ないError
      messages.push(`受払日を入力してください。`)
      hasError = true
    }
    if (備品コード == null) {
      messages.push(`備品コードを入力してください。`)
      hasError = true
    }
    if (備品名 == null) {
      messages.push(`備品名を入力してください。`)
      hasError = true
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }

    return !hasError
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (
        受払日 == null ||
        備品コード == null ||
        備品名 == null ||
        サイズ == null ||
        単位 == null ||
        ロット == null ||
        払出単価 == null ||
        受入数量 == null ||
        在庫場所 == null ||
        備考 == null
      )
        return
      // 更新は以下もcheck
      if (id && 在庫数量 == null) return

      let data = {
        受払日,
        備品コード,
        備品名,
        サイズ,
        単位,
        ロット,
        在庫数量,
        払出単価,
        在庫場所,
        受入数量,
        備考,
        更新日時,
        受払区分: e受払区分.受入,
      }
      const service = new BihinzaikoService()

      let res: TApiResponse<boolean>

      if (id) {
        res = await service.putUkeire(id, data)
      } else {
        res = await service.postUkeire(data)
      }

      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`備品在庫受入の${buttonName}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    // id存在時はデータを取得し更新
    if (id) {
      getData(id).finally(() => {
        disPatch(画面ロック解除())
      })
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    } else {
      disPatch(画面ロック解除())
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])
  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">
              備品在庫受入{id ? `` : `（新規追加）`}
            </span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 受払日 */}
                  <MasterRegisterFormRow label="受払日" isRequired={true}>
                    <div className="w-10rem">
                      <DateInput
                        autoFocus={true}
                        id="受払日"
                        value={受払日}
                        setValue={(v) => {
                          set受払日(v!)
                        }}
                        placeholder="受払日"
                        isRequired={true}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備品コード */}
                  <MasterRegisterFormRow label="備品コード" isRequired={true}>
                    <div className="w-15rem">
                      <TextInput
                        id="備品コード"
                        name="備品コード"
                        value={備品コード}
                        setValue={set備品コード}
                        isReadOnly={id ? true : false}
                        maxLength={15}
                        placeholder="備品コード"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備品名 */}
                  <MasterRegisterFormRow label="品名" isRequired={true}>
                    <div className="w-100rem">
                      <TextInput
                        id="備品名"
                        name="備品名"
                        value={備品名}
                        setValue={set備品名}
                        isReadOnly={id ? true : false}
                        maxLength={100}
                        placeholder="品名"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* サイズ */}
                  <MasterRegisterFormRow label="サイズ">
                    <div className="w-15rem">
                      <TextInput
                        id="サイズ"
                        name="サイズ"
                        value={サイズ}
                        setValue={setサイズ}
                        isReadOnly={id ? true : false}
                        maxLength={50}
                        placeholder="サイズ"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 単位 */}
                  <MasterRegisterFormRow label="単位">
                    <div className="w-15rem">
                      <TextInput
                        id="単位"
                        name="単位"
                        value={単位}
                        setValue={set単位}
                        isReadOnly={id ? true : false}
                        maxLength={50}
                        placeholder="単位"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* ロット */}
                  <MasterRegisterFormRow label="ロット">
                    <div className="w-15rem">
                      <TextInput
                        id="ロット"
                        name="ロット"
                        value={ロット}
                        setValue={setロット}
                        isReadOnly={id ? true : false}
                        maxLength={50}
                        placeholder="ロット"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 払出単価 */}
                  <MasterRegisterFormRow label="払出単価" isRequired={false}>
                    <div className="w-15rem wj-align-right">
                      <wjrInput.InputNumber
                        style={{ width: "5rem" }}
                        id="払出単価"
                        name="払出単価"
                        format={"N0"}
                        isRequired={false}
                        value={払出単価}
                        valueChanged={(c: wjcInput.InputNumber, e: any) => {
                          c.value != null
                            ? set払出単価(c.value)
                            : set払出単価(0)
                        }}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 在庫数量 */}
                  {id && (
                    <MasterRegisterFormRow label="在庫数量">
                      <div className="w-15rem">
                        <wjrInput.InputNumber
                          style={{ width: "5rem" }}
                          id="在庫数量"
                          name="在庫数量"
                          format={"N0"}
                          isRequired={false}
                          isReadOnly={true}
                          value={在庫数量}
                          valueChanged={(c: wjcInput.InputNumber, e: any) => {
                            c.value != null
                              ? set在庫数量(c.value)
                              : set在庫数量(0)
                          }}
                        />
                      </div>
                    </MasterRegisterFormRow>
                  )}
                  {/* 受入数量 */}
                  <MasterRegisterFormRow label="受入数量" isRequired={true}>
                    <div className="w-15rem">
                      <wjrInput.InputNumber
                        style={{ width: "5rem" }}
                        id="受入数量"
                        name="受入数量"
                        format={"N0"}
                        isRequired={false}
                        value={受入数量}
                        valueChanged={(c: wjcInput.InputNumber, e: any) => {
                          c.value != null
                            ? set受入数量(c.value)
                            : set受入数量(0)
                        }}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 在庫場所 */}
                  <MasterRegisterFormRow label="在庫場所">
                    <div className="w-100rem">
                      <TextInput
                        id="在庫場所"
                        name="在庫場所"
                        value={在庫場所}
                        setValue={set在庫場所}
                        maxLength={50}
                        placeholder="在庫場所"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備考 */}
                  <MasterRegisterFormRow label="備考">
                    <div className="w-100rem">
                      <TextAreaInput
                        id="備考"
                        name="備考"
                        value={備考}
                        setValue={set備考}
                        placeholder="備考"
                      />
                    </div>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
                setButtonName(id ? "更新" : "登録")
              }}>
              {id ? `更新` : `登録`}
            </Button>
          </Col>
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{buttonName}しますか？
      </ConfirmModal>
    </>
  )
}

export default PurchaseBihinzaikoRegister

//#endregion
